import Header from "@/components/marketing/Header";
import Hero from "@/components/marketing/Hero";
import Trust from "@/components/marketing/Trust";
import Services from "@/components/marketing/Services";
import BookAndPay from "@/components/marketing/BookAndPay";
import Process from "@/components/marketing/Process";
import QuoteForm from "@/components/marketing/QuoteForm";
import DriverForm from "@/components/marketing/DriverForm";
import CtaBand from "@/components/marketing/CtaBand";
import Footer from "@/components/marketing/Footer";

export default function Landing() {
  return (
    <div className="bg-ksy-bg" data-testid="landing-page">
      <Header />
      <Hero />
      <Trust />
      <Services />
      <BookAndPay />
      <Process />
      <QuoteForm />
      <DriverForm />
      <CtaBand />
      <Footer />
    </div>
  );
}
